module.exports = __webpack_public_path__ + "static/media/bg3.d34a2652.jpg";